import { Observable, ObservableArray, PureComputed } from 'knockout';
import WCCEntity from './entity';

export interface CommentsFiltersConfig {
    searchString?: string
    peopleTagsIDs?: Array<string>
}

export default class CommentsFilters extends WCCEntity<CommentsFiltersConfig> {
    searchString: Observable<string>
    peopleTagsIDs: ObservableArray<string>

    isActive: PureComputed<boolean>

    constructor(config?: CommentsFiltersConfig) {
        super();

        this.searchString = this.createField(config, 'searchString', '');
        this.peopleTagsIDs = this.createCollection(config, 'peopleTagsIDs');

        this.isActive = ko.pureComputed(() => this.searchString().length > 0 || this.peopleTagsIDs().length > 0);
    }
}